/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_ReadyInputs */

const en_directory_submit_content_ready = /** @type {(inputs: Directory_Submit_Content_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content ready — all set to save the draft.`)
};

const zh_directory_submit_content_ready = /** @type {(inputs: Directory_Submit_Content_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容已就绪 — 可保存草稿。`)
};

/**
* | output |
* | --- |
* | "Content ready — all set to save the draft." |
*
* @param {Directory_Submit_Content_ReadyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_ready = /** @type {((inputs?: Directory_Submit_Content_ReadyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_ReadyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_ready(inputs)
	return zh_directory_submit_content_ready(inputs)
});
export { directory_submit_content_ready as "directory.submit.content.ready" }